import VimeoVideo from "./class-vimeo.js";
import YoutubeVideo from "./class-youtube.js";
import Cookies from "js-cookie";

var Whitepages = {
  add_blocks: function (data) {
    for (var block of data) {
      if (block.type === "text") {
        this.add_text_block(block);
      } else if (block.type === "picture") {
        this.add_picture_block(block);
      } else if (block.type === "vimeo") {
        this.add_vimeo_block(block);
      } else if (block.type === "youtube") {
        this.add_youtube_block(block);
      }
    }
  },

  add_text_block: function (data) {
    var block = document.createElement("div");
    block.className = "block text";
    block.innerHTML = data.content;
    document.querySelector(".content-blocks").appendChild(block);
  },

  add_picture_block: function (data) {
    var block = document.createElement("div");
    block.className = "block picture";
    var img = document.createElement("img");
    img.draggable = false;
    img.src = data.content.url;
    block.appendChild(img);
    document.querySelector(".content-blocks").appendChild(block);
  },

  add_vimeo_block: function (data) {
    var block = document.createElement("div");
    block.className = "block video";
    var video = document.createElement("div");
    video.className = "vimeo-video";
    video.setAttribute("data-id", data.content);
    block.appendChild(video);
    document.querySelector(".content-blocks").appendChild(block);

    var vid = new VimeoVideo(video);
    vid.pin_width();
    vid.add_tracking();

    if (typeof News !== 'undefined'){
      News.set_media_order();  
    }
  },

  add_youtube_block: function (data) {
    var block = document.createElement("div");
    block.className = "block video";
    var video = document.createElement("div");
    video.className = "youtube-video";
    video.setAttribute("data-id", data.content);
    block.appendChild(video);
    document.querySelector(".content-blocks").appendChild(block);

    var vid = new YoutubeVideo(video);
    vid.pin_width();
    vid.add_tracking();

    if (typeof News !== 'undefined'){
      News.set_media_order();  
    }
    
  },

  build_page: function () {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "/whitepages/" + this.id + ".json", true);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            var data = JSON.parse(xhr.responseText);
            var relatedContent = data.relatedProjects;

            // ✅ Check if elements exist before modifying `.style`
            var formRow = document.querySelector(".form-row");
            if (formRow) {
              formRow.style.display = "none";
            }

            var previewBlock = document.querySelector(".preview.text.block");
            if (previewBlock) {
              previewBlock.style.display = "none";
            }

            var mailingList = document.querySelector(".mailing-list");
            if (mailingList) {
              mailingList.style.display = "block";
            }

            Whitepages.add_blocks(data.content);

            if (relatedContent.length) {
              var relatedBlock = document.createElement("div");
              relatedBlock.className = "block text related-projects";
              relatedBlock.innerHTML = "<h2>Related Projects</h2>";
              document.querySelector(".content-blocks").appendChild(relatedBlock);

              relatedContent.forEach(function (element) {
                var relatedProject = document.createElement("p");
                var relatedLink = document.createElement("a");
                relatedLink.href = element.url;
                relatedLink.textContent = element.title;
                relatedProject.appendChild(relatedLink);
                relatedBlock.appendChild(relatedProject);
              });
            }
          } else {
              console.error("🚨 Error loading whitepaper content. Status:", xhr.status);
          }
        }
    };
    xhr.send();
  },

  init: function () {
    this.id = document.querySelector(".entry-id").getAttribute("data-id");

    if (typeof News !== 'undefined'){
        News.set_media_order();
    }

    // If the user has already filled out the form, show content immediately
    if (Cookies.get("whitepages-ok")) {
        this.build_page();
        return; // Stop execution since form is not needed
    }

    var startButton = document.querySelector(".form-row .start.button");
    var formieForm = document.querySelector(".formie-container .whitepages-form");

    startButton.addEventListener("click", function () {
        startButton.style.display = "none"; // Hide "Start" button
        formieForm.style.display = "block"; // Show Formie form
    });

    // Listen for Formie form submission success
    document.addEventListener("DOMContentLoaded", function () {
      console.log("🔄 Listening for Formie submission event...");
  
      let form = document.querySelector('.formie-container form');
      
      if (form) {
          form.addEventListener("onAfterFormieSubmit", function (e) {
              e.preventDefault();
              console.log("✅ Formie form submitted successfully!", e.detail);
  
              // Unlock the page content
              Whitepages.build_page();
  
              // Store cookie to prevent repeat form submission
              Cookies.set("whitepages-ok", "true", { expires: 365 });
  
              // Hide the form after successful submission
              form.style.display = "none";
          });
      } else {
          console.error("🚨 No Formie form found to attach event listener.");
      }
    });
  },
};

if (document.querySelector(".whitepaper-page")) {
  Whitepages.init();
}
